export default "/images/4c6e32575c6c0448c3dd611dae569675.avif";